import React from 'react'
import SuccessIcon from 'transfix-icons/build/SuccessIcon'
import { Box } from 'transfix-ui/core'

interface ISafetyLetterProps {
  safetyLetter?: {
    id?: number
    parentUserId?: number
    fullName?: string
  }
  notApplicableSafetyLetter: {
    id?: number
    nAParentUserId?: number
    fullName?: string
  }
}

export const SafetyLetter: React.FunctionComponent<ISafetyLetterProps> = React.memo(
  ({ notApplicableSafetyLetter, safetyLetter }) => {
    const { fullName, parentUserId } = safetyLetter || {}
    const { id: nAId, nAParentUserId } = notApplicableSafetyLetter || {}
    const isNotApplicable = notApplicableSafetyLetter
      ? notApplicableSafetyLetter.fullName
      : undefined
    return (
      <div className='pv4'>
        {!fullName && !isNotApplicable ? (
          <span>
            Safety Letter<p className='text-secondary'>Not Reviewed</p>
          </span>
        ) : (
          <span>
            {isNotApplicable && nAId && !fullName ? (
              <div>
                Safety Letter (if applicable)
                <p className='text-secondary'>
                  Not Applicable - Reviewed by&nbsp;
                  <a
                    href={`${__ROOT__}/users/${nAParentUserId}`}
                    data-test='section-id-reviewer'
                    target='_blank'
                    rel='noopener noreferrer'>
                    {notApplicableSafetyLetter.fullName}
                  </a>
                </p>
              </div>
            ) : (
              <div>
                <Box component='span' position='relative' top='4px'>
                  <SuccessIcon color='info' size='large' />
                </Box>
                &nbsp;SafetyLetter (if applicable)
                <p className='text-secondary'>
                  Reviewed by&nbsp;
                  <a
                    href={`${__ROOT__}/users/${parentUserId}`}
                    data-test='section-id-reviewer'
                    target='_blank'
                    rel='noopener noreferrer'>
                    {fullName}
                  </a>
                </p>
              </div>
            )}
          </span>
        )}
      </div>
    )
  }
)
